<template>
  <calendar />
</template>

<script>
import Calendar from "../../components/Calendar.vue";

export default {
  name: "LessonCalendar",
  components: {
    Calendar,
  },
};
</script>
